import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import HotNewsSection from './components/HotNewsSection';
import LatestNewsSection from './components/LatestNewsSection';
import CommentSection from './components/CommentSection';
import CTASection from './components/CTASection';
import { buildWebPageSchema, buildFAQSchema } from '@/mocks/schema';

const webPageSchema = buildWebPageSchema({
  title: '51吃瓜每日大赛 | 51吃瓜网今日吃瓜资源与51吃瓜黑料网 | 每日吃瓜爆料入口',
  description: '51吃瓜每日大赛作为吃瓜爆料核心站点，提供51吃瓜网今日吃瓜资源、51吃瓜黑料网及51吃瓜入口，每日不间断追踪娱乐圈网红内幕、明星翻车现场，全部内容免费浏览。',
  url: 'https://51chigua.com/',
  dateModified: '2026-07-07',
});

const faqSchema = buildFAQSchema([
  {
    question: '51吃瓜每日大赛是什么？',
    answer: '51吃瓜每日大赛是一个专注于娱乐圈和网红圈爆料的资讯平台，每日更新最新的明星翻车、网红八卦、黑料曝光等内容，全部免费浏览。',
  },
  {
    question: '51吃瓜网的内容多久更新一次？',
    answer: '51吃瓜网实行7×24小时不间断更新机制，专业编辑团队全天候监控各大社交平台，确保第一时间为您呈现最新爆料。',
  },
  {
    question: '如何向51吃瓜投稿爆料？',
    answer: '您可以通过网站底部的投稿表单或关于我们页面的联系方式向我们提供爆料线索，我们会严格保护爆料人隐私。',
  },
  {
    question: '51吃瓜黑料网的内容可信吗？',
    answer: '51吃瓜黑料网的所有爆料内容都经过多方交叉验证，我们坚持真实性第一的原则，杜绝发布未经证实的虚假信息。',
  },
]);

export default function Home() {
  return (
    <>
      <SchemaOrg data={webPageSchema} />
      <SchemaOrg data={faqSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <HotNewsSection />
        <LatestNewsSection />
        <CommentSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}